// Add authentication token to every request
export const authInterceptor = config => {
  const token = localStorage.getItem('msalAccessToken') || 'not_required'
  config.headers.countryCode = localStorage.getItem('countryCode') || 'MX'
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

// Attach the interceptor to an Axios instance
export const attachAuthInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(authInterceptor, error => Promise.reject(new Error(error)))
}
